import { POLICYTYPE } from '~/modules/common/enums';
import roleFacet from '~/modules/common/components/SearchBox/Facets/RoleFacet';
import ResourcePoolFacet from '~/modules/common/components/SearchBox/Facets/ResourcePoolFacet';
import {
  ProjectResourceFacet,
  getFacet
} from '~/modules/common/components/SearchBox/Facets/UserFacet';

export const buildProjectResourceUserFacet = (
  projectId,
  useResourcePlanFilterUsers
) => {
  const useProjectFilterUsers = searchTerm =>
    useResourcePlanFilterUsers(projectId, searchTerm);

  return getFacet(POLICYTYPE.PROJECT_MANAGEMENT, useProjectFilterUsers);
};

const getFacets = (
  projectId,
  isPsaRmpEnhancedProjectManagerPersonaEnabled,
  useResourcePlanFilterUsers
) => [
  isPsaRmpEnhancedProjectManagerPersonaEnabled
    ? buildProjectResourceUserFacet(projectId, useResourcePlanFilterUsers)
    : ProjectResourceFacet,
  roleFacet,
  ResourcePoolFacet
];

export default getFacets;
